import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ExpenseCreate = lazyLoader(
  () => import("Containers/Expense/ExpenseCreate/ExpenseCreate"),
);

export const CreateExpensePage = () => {
  return (
    <Layout>
      <ExpenseCreate />
    </Layout>
  );
};
